/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   11/11/21
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {addWeeks, startOfWeek} from "date-fns";
import {locale} from "../../dates-helper";

export type RangeState = Interval;

const start = startOfWeek(new Date(), { locale });

const defaultRange: Interval = {
	start: start.getTime(),
	end: addWeeks(start, 6).getTime()
}

export const slice = createSlice({
	name: 'range',
	initialState: defaultRange,
	reducers: {
		set: (state, action: PayloadAction<RangeState>) => action.payload,
	},
});

export const { set } = slice.actions;
export default slice.reducer;
